export default "__VITE_ASSET__qi0lcsm___"